import React from 'react';
import { useTranslation } from 'react-i18next';

import { Formik, Form } from 'formik';

import FormCheckboxGroup from 'components/FormCheckboxGroup/FormCheckboxGroup';
import withoutEnterSubmit from 'components/withoutEnterSubmit';

import { EventType } from 'pages/Accounts/Edit/Plan/Chart/model';

const FormWithoutEnterSubmit = withoutEnterSubmit(Form);

interface Props {
  initial: EventType[];
  handleSetFilter: (filter: EventType[]) => void;
}

const DevelopmentFilter: React.FC<Props> = ({ initial, handleSetFilter }) => {
  const { t } = useTranslation();

  return (
    <Formik initialValues={{ filter: initial }} onSubmit={() => {}}>
      {(formikProps) => (
        <FormWithoutEnterSubmit>
          <span>{t('accountDetail_graph_filter')}</span>
          <FormCheckboxGroup
            name={'filter'}
            values={formikProps.values.filter}
            // FIXME: define colors here, not in CSS
            options={[EventType.DEPOSIT, EventType.PERIODIC_DEPOSIT, EventType.TARGET, EventType.WITHDRAWAL]}
            fast={false}
            optPrefix={'accountDetail_graph_filter_'}
            label={''}
            afterChange={() => {
              handleSetFilter(formikProps.values.filter);
            }}
          />
        </FormWithoutEnterSubmit>
      )}
    </Formik>
  );
};

export default React.memo(DevelopmentFilter);
